namespace Serenity {
    export interface ToolButton {
        title?: string;
        hint?: string;
        cssClass?: string;
        icon?: string;
        onClick?: any;
        htmlEncode?: any;
        hotkey?: string;
        hotkeyAllowDefault?: boolean;
        hotkeyContext?: any;
        separator?: (false | true | "left" | "right" | "both");
        visible?: boolean | (() => boolean);
        disabled?: boolean | (() => boolean);
    }

    export interface PopupMenuButtonOptions {
        menu?: JQuery;
        onPopup?: () => void;
        positionMy?: string;
        positionAt?: string;
    }

    @Decorators.registerEditor("Serenity.PopupMenuButton")
    export class PopupMenuButton extends Widget<PopupMenuButtonOptions> {
        constructor(div: JQuery, opt: PopupMenuButtonOptions) {
            super(div, opt);

            div.addClass("s-PopupMenuButton");
            div.on("click", e => {
                e.preventDefault();
                e.stopPropagation();

                if (this.options.onPopup != null) {
                    this.options.onPopup();
                }

                var menu = this.options.menu;
                menu.show().position({
                    my: this.options.positionMy || "left top",
                    at: this.options.positionAt || "left bottom",
                    of: this.element,
                });

                var uq = this.uniqueName;
                $(document).one(`click.${uq}`, function (x: JQueryEventObject) {
                    menu.hide();
                });
            });

            this.options.menu.hide().appendTo(document.body).addClass("s-PopupMenu").menu();
        }

        destroy() {
            if (this.options.menu != null) {
                this.options.menu.remove();
                this.options.menu = null;
            }

            super.destroy();
        }
    }

    export interface PopupToolButtonOptions extends PopupMenuButtonOptions {
    }

    @Decorators.registerEditor("Serenity.PopupToolButton")
    export class PopupToolButton extends PopupMenuButton {
        constructor(div: JQuery, opt: PopupToolButtonOptions) {
            super(div, opt);

            div.addClass("s-PopupToolButton");
            $("<b />").appendTo(div.children(".button-outer").children("span"));
        }
    }

    export interface ToolbarOptions {
        buttons?: ToolButton[];
        hotkeyContext?: any;
    }

    @Decorators.registerClass("Serenity.Toolbar")
    export class Toolbar extends Widget<ToolbarOptions> {
        protected mouseTrap: any;

        constructor(div: JQuery, options: ToolbarOptions) {
            super(div, options);

            this.element.addClass("s-Toolbar clearfix")
                .html(`<div class="tool-buttons"><div class="buttons-outer"><div class="buttons-inner" /></div></div>`);
            let container = $("div.buttons-inner", this.element),
                buttons = this.options.buttons;

            for (let i = 0, len = buttons.length; i < len; i++) {
                this.createButton(container, buttons[i]);
            }
        }

        destroy() {
            this.element.find("div.tool-button").unbind("click");

            if (this.mouseTrap) {
                if (!!this.mouseTrap.destroy) {
                    this.mouseTrap.destroy();
                } else {
                    this.mouseTrap.reset();
                }

                this.mouseTrap = null;
            }

            super.destroy();
        }

        findButton(className: string): JQuery {
            if (className != null && Q.startsWith(className, ".")) {
                className = className.substr(1);
            }

            return $(`div.tool-button.${className}`, this.element);
        }

        updateInterface() {
            this.element.find(".tool-button").each(function (i: number, el: Element) {
                $(el).triggerHandler("updateInterface");
            });
        }

        protected createButton(container: JQuery, b: ToolButton) {
            /* <StartSharp> */
            if (b.separator) {
                container = $('<div class="buttons-inner" />').appendTo(container.parent());
            } else {
                container = container.parent().children().last();
            }
            /* </StartSharp> */

            let cssClass = Q.coalesce(b.cssClass, "");

            if (b.separator === true || b.separator === "left" || b.separator === "both") {
                $('<div class="separator" />').appendTo(container);
            }

            var btn = $(`<div class="tool-button"><div class="button-outer"><span class="button-inner" /></div></div>`)
                .appendTo(container);

            if (b.separator === "right" || b.separator === "both") {
                $('<div class="separator" />').appendTo(container);
            }

            if (cssClass.length) {
                btn.addClass(cssClass);
            }

            if (!Q.isEmptyOrNull(b.hint)) {
                btn.attr("title", b.hint);
            }

            btn.on("click", function (e: JQueryEventObject) {
                if (btn.hasClass("disabled")) {
                    return;
                }

                b.onClick(e);
            });

            let text = b.title;

            if (b.htmlEncode !== false) {
                text = Q.htmlEncode(b.title);
            }

            if (!Q.isEmptyOrNull(b.icon)) {
                btn.addClass("icon-tool-button");
                let klass = b.icon;

                if ((klass as any).startsWith("fa-")) {
                    klass = `fa ${klass}`;
                } else if ((klass as any).startsWith("mdi-")) {
                    klass = `mdi ${klass}`;
                } else if ((klass as any).startsWith("ion-")) {
                    klass = `ion ${klass}`;
                } else if ((klass as any).startsWith("glyphicon-")) {
                    klass = `glyphicon ${klass}`;
                }

                text = `<i class='${klass}' /> ${text}`;
            }

            if (text == null || !text.length) {
                btn.addClass("no-text");
            } else {
                btn.find("span").html(text);
            }

            if (b.visible === false) {
                btn.hide();
            }

            if (b.disabled != null && typeof b.disabled !== "function") {
                btn.toggleClass("disabled", !!b.disabled);
            }

            if (typeof b.visible === "function" || typeof b.disabled == "function") {
                btn.on("updateInterface", () => {
                    if (typeof b.visible === "function") {
                        btn.toggle(!!b.visible());
                    }

                    if (typeof b.disabled === "function") {
                        btn.toggleClass("disabled", !!b.disabled());
                    }
                });
            }

            if (!!(!Q.isEmptyOrNull(b.hotkey) && window["Mousetrap"] != null)) {
                this.mouseTrap = this.mouseTrap || window["Mousetrap"](
                    b.hotkeyContext || this.options.hotkeyContext || window.document.documentElement);

                this.mouseTrap.bind(b.hotkey, function (e1: BaseJQueryEventObject, action: any) {
                    if (btn.is(":visible")) {
                        btn.triggerHandler("click");
                    }

                    return b.hotkeyAllowDefault;
                });
            }

            /* <StartSharp> */
            if (b.separator) {
                container.children().first().remove();
            }
            /* <StartSharp> */
        }
    }
}